import { render, staticRenderFns } from "./CategoryExtraDescription.vue?vue&type=template&id=277abf86&"
import script from "./CategoryExtraDescription.vue?vue&type=script&lang=js&"
export * from "./CategoryExtraDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports